import styled from 'styled-components'
import { useConfigurationContext, useDropOffLocationContext } from '../../core/application/contexts'
import DropOffLocationDetails from '../dropOffLocationDetails/DropOffLocationDetails'
import DropOffLocationList from './DropOffLocationList'

const SideMenu = () => {
  const { wasteTypeFilters, dropOffLocationList, currentDropOffLocation, setCurrentDropOffLocation } =
    useDropOffLocationContext()
  const { wasteTypeList, mostPopularSearches } = useConfigurationContext()

  return (
    <Container data-testid="sideMenu-container">
      {currentDropOffLocation ? (
        <DropOffLocationDetails
          types={currentDropOffLocation.types}
          id={currentDropOffLocation.storeId}
          name={currentDropOffLocation.name}
          address={currentDropOffLocation.address}
          coordinate={currentDropOffLocation.coordinate}
          pictures={currentDropOffLocation.pictures}
          phone={currentDropOffLocation.contact?.phone}
          website={currentDropOffLocation.contact?.website}
          availableWasteTypes={currentDropOffLocation.acceptedWasteIds}
          schedule={currentDropOffLocation.schedule}
          onReturn={() => setCurrentDropOffLocation(undefined)}
          isOpenNow={currentDropOffLocation.isOpenNow}
        />
      ) : (
        <DropOffLocationList
          dropOffLocations={dropOffLocationList}
          onSelectItem={setCurrentDropOffLocation}
          mostPopularSearchTerms={mostPopularSearches}
          wasteTypeList={wasteTypeList}
          isSearching={wasteTypeFilters.length > 0}
        />
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  padding: 24px;
  width: 340px;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 24px;
  margin-left: 24px;
  background-color: ${({ theme }) => theme.color.background};
  height: 100%
`

export default SideMenu
